import React from "react";
import Banner from "./Banner";
import Footer from "./Footer";

const Video = () => {
  return (
    <>
      <Banner />

      <div className="home_header">
        <h1 className="home_header">OUR VIDEO</h1>
        </div>


      <div className="video_container">
        <div className="video_row">
          <div className="youtube_video">
            <iframe
              width="350"
              height="300"
              src="https://www.youtube.com/embed/zlW46JJ58Lg"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="youtube_video">
            <iframe
              width="350"
              height="300"
              src="https://www.youtube.com/embed/dEYs847mt_w"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="youtube_video">
            <iframe
              width="360"
              height="300"
              src="https://www.youtube.com/embed/wh7zwl0SUF4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
        </div>
        <div className="video_row">
          <div className="youtube_video">
            <iframe
              width="350"
              height="300"
              src="https://www.youtube.com/embed/QC-9EHL0k6M"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="youtube_video">
            <iframe
              width="350"
              height="300"
              src="https://www.youtube.com/embed/P5peyOa-phs"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="youtube_video">
            <iframe
              width="350"
              height="300"
              src="https://www.youtube.com/embed/f9qlJN2KXZ0"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
        </div>
      </div>

     
      <div className="home_video_tab">
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/zlW46JJ58Lg"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/dEYs847mt_w"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/wh7zwl0SUF4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/QC-9EHL0k6M"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/P5peyOa-phs"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/f9qlJN2KXZ0"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/dEYs847mt_w"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/wh7zwl0SUF4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/I0zMuwAthv4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/vM1bUk6zKIo"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/iH9YXUd0OsU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/ud3nEkSLVcI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/ub5Vx-JTtk8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/2kwDDptgVng"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/Ovq_JuoePmA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/9gWHKmnvnT8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/deFaIPp60Qk"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>

     

      <Footer />
    </>
  );
};

export default Video;
